var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.182 14.32l2.667 2.667 6-6m6 17.333v-17.6c0-2.24 0-3.36-.436-4.216a4 4 0 00-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.533c-2.24 0-3.36 0-4.216.436a4 4 0 00-1.748 1.748c-.436.856-.436 1.976-.436 4.216v17.6l3.666-2.666 3.334 2.666 3.666-2.666 3.667 2.666 3.333-2.666 3.667 2.666z",
    stroke: "#2C5BFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/landing/receipt-check-icon-14ca1c72.svg";
export { SvgReceiptCheckIcon as ReactComponent };